const REFERRAL_QUESTION = 'Did a current or former Amber Peak tenant refer you?';
const REFERRAL_OFFER =
  '$100 for you, $100 for the referring tenant when your group finalizes a lease.';

interface ReferralProgramPromoProps {
  compactColumn?: boolean;
}

export function ReferralProgramPromo({ compactColumn = false }: ReferralProgramPromoProps) {
  if (compactColumn) {
    return (
      <div
        className="mt-2 rounded-xl border border-amber-200/90 bg-gradient-to-br from-amber-50 to-orange-50/80 px-3 py-2.5 dark:border-amber-500/35 dark:from-amber-950/80 dark:to-amber-950/40"
        role="note"
      >
        <p className="text-sm font-semibold leading-snug text-gray-900 dark:text-white">{REFERRAL_QUESTION}</p>
        <p className="mt-1.5 text-sm leading-snug text-gray-900 dark:text-white">{REFERRAL_OFFER}</p>
        <p className="mt-1.5 text-xs leading-snug text-gray-700 dark:text-gray-200">
          Google, social media, and ads don&apos;t qualify. Limit one referral gift per group that signs a lease.
        </p>
      </div>
    );
  }

  return (
    <div
      className="mt-3 rounded-xl border border-amber-200/90 bg-gradient-to-br from-amber-50 to-orange-50/80 px-4 py-3.5 dark:border-amber-500/35 dark:from-amber-950/80 dark:to-amber-950/40"
      role="note"
    >
      <p className="text-base font-semibold leading-snug text-gray-900 dark:text-white">{REFERRAL_QUESTION}</p>
      <p className="mt-2 text-sm leading-snug text-gray-900 dark:text-white">{REFERRAL_OFFER}</p>
      <ul className="mt-2.5 list-disc space-y-1 pl-5 text-sm leading-snug text-gray-700 dark:text-gray-200">
        <li>Limit one referral gift per group that signs a lease.</li>
        <li>
          Google, social media, websites, and other advertising do <span className="font-medium">not</span> qualify for
          this payment (you can still tell us how you found us).
        </li>
      </ul>
    </div>
  );
}
